import React from 'react';
import './Modal.css'; // Assuming there's a common modal CSS

const CancelSubscriptionModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h2>Cancel Subscription</h2>
          <button className="modal-close-button" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <p>Are you sure you want to cancel your subscription?</p>
          <p>You will continue to have access until the end of your current billing period. After that, you'll still have read-only access to your work.</p>
        </div>
        <div className="modal-footer">
          <button className="modal-button-secondary" onClick={onClose}>Keep Subscription</button>
          <button className="modal-button-danger" onClick={onConfirm}>Cancel Subscription</button>
        </div>
      </div>
    </div>
  );
};

export default CancelSubscriptionModal;
